<template>
  <div class="aio">
    <div v-if="!dialogVisible" class="aio-logo" @click="open">
      <img :src="proceduresImg" />
      <div>AI办公精灵</div>
    </div>
    <!-- <div class="dialog" v-show="dialogVisible"> -->
    <div class="dialog" v-show="dialogVisible">
      <div class="dialog-title">
        AI办公精灵
        <i class="el-icon-circle-close" @click="handleClose"></i>
      </div>
      <div class="dialog-chat" ref="chatBox">
        <div v-show="messages.length == 0" style="text-align: center">
          <img
            src="../../../assets/ai_logo.png"
            alt="Assistant Avatar"
            class="avatar"
            width="200px"
          />
          <p style="font-size: 20px; color: #333">我是AI办公精灵</p>
          <p style="font-size: 12px; color: #aaa">
            可以帮你查找文档、智能扩写、公文润色、文案校对、信息摘要、内容翻译
          </p>
        </div>
        <div v-for="(x, i) in messages" :key="i" v-show="messages.length > 0">
          <!-- ai回答 -->
          <div v-if="x.role === 'assistant'" class="flex mb-10">
            <div class="chat-user">
              <div class="avatar-box-agent">
                <img
                  src="../../../assets/default_agent.png"
                  alt="Assistant Avatar"
                  class="avatar"
                />
              </div>
              <div v-if="!x.thinking">
                <div class="spinner">
                  <div class="spinner-box flex-center"></div>
                </div>
                <div class="spinner-text">飞速思考中...</div>
              </div>
              <div
                v-else
                v-html="markMessage(x.thinking)"
                class="thinking"
              ></div>
            </div>
          </div>
          <!-- 用户 -->
          <div v-if="x.role === 'user'" class="flex justify-end mb-10">
            <div class="chat-user">
              <div class="message-content">{{ x.content }}</div>
              <div class="avatar-box-user">
                <img
                  src="../../../assets/default_user.png"
                  alt="User Avatar"
                  class="avatar"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-foot">
        <el-input
          v-model="userInput"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 3 }"
          resize="none"
          maxlength="300"
          show-word-limit
          placeholder="请描述你的问题，最多300字"
          style="
            width: 100%;
            flex: 1;
            opacity: 0.8;
            margin: 10px;
            border-radius: 10px;
          "
          @keyup.enter="sendMessage"
        />
        <div
          @click="sendMessage"
          class="btn-top flex-center"
          :class="{ active: userInput }"
        >
          <i class="el-icon-top"></i>
        </div>
      </div>

      <div class="new-chat" @click="newChat" v-show="messages.length != 0">
        <Icon type="ios-chatboxes-outline" />
        开启新对话
      </div>
    </div>
  </div>
</template>

<script>
import proceduresImg from '@/assets/czsc.png';
import { Marked } from 'marked';
import { markedHighlight } from 'marked-highlight';
import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';
import 'highlight.js/styles/paraiso-light.css';

export default {
  props: {},
  data() {
    return {
      proceduresImg,
      dialogVisible: false,
      userInput: '',
      messages: [], // 消息记录
      pollingActive: false, // 是否正在长轮询
      isEnd: false, // 标记是否结束轮询
      currentAiMessageId: null, // 当前正在回复的 AI 消息的 ID
      userMsgData: {}, // 用户消息数据
      query: {
        bot_id: '7480531576343330870',
        user_id: '填用户的ID',
        stream: true,
        auto_save_history: true,
        additional_messages: [],
      },
      outputFlag: false,
      statusType: 0,
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    open() {
      this.dialogVisible = true;
      //this.sendMessage();
    },
    newChat() {
      this.messages = [];
    },
    handleClose() {
      this.userInpu = '';

      this.userMsgData = {};
      this.pollingActive = false;
      this.isEnd = false;
      this.currentAiMessageId = null;
      this.query = {
        bot_id: '7480531576343330870',
        user_id: 'AO',
        stream: true,
        auto_save_history: true,
        additional_messages: [],
      };
      this.dialogVisible = false;
    },

    markMessage(message) {
      const marked = new Marked(
        markedHighlight({
          pedantic: false,
          gfm: true, // 开启gfm
          breaks: true,
          smartLists: true,
          xhtml: true,
          async: false, // 如果是异步的，可以设置为 true
          langPrefix: 'hljs language-', // 可选：用于给代码块添加前缀
          emptyLangClass: 'no-lang', // 没有指定语言的代码块会添加这个类名
          highlight: (code) => {
            return hljs.highlightAuto(code).value;
          },
        }),
      );
      let markedMessage = marked.parse(message);
      // markedMessage = markedMessage.replace(/<table/g, '<div style="max-width: 670px;max-height:350px;overflow: auto;"><table');
      // markedMessage = markedMessage.replace(/<\/table>/g, '</table></div>');
      // markedMessage = markedMessage.replace(/<th>/g, '<th style="white-space: nowrap; padding-left: 5px; padding-right: 5px;">');
      // markedMessage = markedMessage.replace(/<td>/g, '<th style="white-space: nowrap;padding: 5px;">');
      return markedMessage;
    },
    sendMessage() {
      if (!this.userInput.trim()) return;

      // 添加用户消息
      this.messages.push({
        id: Date.now(),
        content: this.userInput,
        role: 'user',
      });

      this.userMsgData.content = this.markMessage(this.userInput);
      // send(this.userMsgData);

      // 清空输入框
      this.userInput = '';

      // 启动轮询
      // if (this.isEnd || !this.pollingActive) {
      //   this.isEnd = false;
      //   this.pollingActive = true;
      //   this.polling();
      // }
      this.polling();
    },
    // 调用接口
    async ask(message) {
      this.query.additional_messages = [message[message.length - 1]];
      try {
        const response = await fetch('https://api.coze.cn/v3/chat', {
          method: 'POST',
          body: JSON.stringify(this.query),
          headers: {
            'Content-Type': 'application/json', // 设置 Content-Type 为 application/json
            Authorization: `Bearer pat_A8LU8wqwR2wCciWw3poGUvYr2izhtuM9IAItyRhfW0gJK3UFSDOcXhfWAURae2NQ`,
          },
        });
        return response;
      } catch (error) {
        console.error('请求失败:', error);
      }
    },
    async polling() {
      try {
        // 请求结果
        const response = await this.ask(this.messages);
        // 添加 AI 回复占位
        let newAiMessage = {
          id: Date.now() + 1,
          thinking: '',
          answer: '',
          question: '',
          role: 'assistant',
        };
        this.messages.push(newAiMessage);

        this.currentAiMessageId = newAiMessage.id;

        if (!response.ok) {
          throw new Error(`请求失败状态码 ${response.status}`);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = ''; // 用于累积部分消息
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            this.isEnd = true;
            this.pollingActive = false;
            break;
          }
          buffer = decoder.decode(value, { stream: true });
          this.processServerSentEvent(buffer);
        }
        // 流结束时处理可能剩余的部分消息
        // this.processServerSentEvent(buffer);
      } catch (e) {
        console.log(e.toString());
      }
    },
    processServerSentEvent(eventData) {
      const lines = eventData.split('\n');
      let currentMessage = '';
      lines.forEach((line) => {
        if (line.startsWith('data:')) {
          let newLine = line.substring(5);
          // console.log('收到数据:  ' + newLine);
          try {
            var obj = JSON.parse(newLine);
            if (obj.content) {
              let msg = '';
              try {
                msg = obj.content;
              } catch {
                msg = obj.content;
              }
              this.addNewMessage(msg);
            }
          } catch {
            console.log('-');
          }
        } else if (line.startsWith('event:')) {
          let newLine = line.substring(6);
          switch (newLine.trim()) {
            //会话开始
            case 'conversation.chat.created':
              break;
            //与查找相关的信息
            case 'conversation.chat.in_progress':
              break;
            //吐字
            case 'conversation.message.delta':
              this.statusType = 1;
              break;
            //上一个动作完成
            case 'conversation.message.completed':
              if (this.statusType == 1) this.statusType = 2;
              else if (this.statusType == 2) this.statusType = 3;
              else this.statusType = 0;
              break;
            //会话结束
            case 'conversation.chat.completed':
              break;
            //完成
            case 'done':
              break;
          }
        }
      });
      this.addNewMessage(currentMessage);
    },
    addNewMessage(data) {
      if (data) {
        try {
          let newMessageContent = data;
          // 通过消息id获取目前的AI输入位置
          const aiMessage = this.messages.find(
            (msg) => msg.id === this.currentAiMessageId,
          );
          // newMessageContent = this.markMessage(newMessageContent)
          if (aiMessage) {
            if (this.statusType == 1)
              aiMessage.thinking = `${aiMessage.thinking}${newMessageContent}`;
            else if (this.statusType == 2) aiMessage.answer = newMessageContent;
            else if (this.statusType == 3)
              aiMessage.question = `${newMessageContent}`;
          }
          this.scrollToBottom();
        } catch (error) {
          console.error('Failed to parse JSON:', error);
        }
      }
    },
    scrollToBottom() {
      const chatBox = this.$refs.chatBox;
      chatBox.scrollTop = chatBox.scrollHeight;
    },
  },
};
</script>

<style scoped lang="less">
.aio {
  &-logo {
    position: fixed;
    display: block;
    right: -5px;
    bottom: 230px;
    padding: 5px;
    text-align: center;
    z-index: 9;
    color: #2d2d30;
    font-weight: bold;
    background: linear-gradient(137.48deg, #cef8ff 50%, #9affec 45%);
    border-radius: 8px;
    cursor: pointer;
    width: 30px;
    font-size: 12px;
    transition: 600ms;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* 更新阴影效果 */
    img {
      display: none;
    }
    &:hover {
      right: 7px;
      padding: 5px;
      width: 80px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: linear-gradient(137.48deg, #cef8ff 50%, #9affec 45%);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4); /* 更新阴影效果 */
      transition: 700ms;
      img {
        display: block !important;
        width: 30px;
        height: 30px;
      }
      &::after {
        content: '';
        position: absolute;
        top: -5px;
        left: -5px;
        right: -5px;
        bottom: -5px;
        border-radius: 12px;
        box-shadow: 0 0 50px rgba(66, 230, 149, 0.7); /* 添加发光效果 */
        pointer-events: none;
        z-index: -1;
      }
    }
  }
}
.dialog {
  position: fixed;
  z-index: 9999;
  right: 50px;
  bottom: 100px;
  width: 550px; /* 固定宽度 */
  height: 600px; /* 固定高度 */
  background: #ffffff; /* 美化背景颜色 */
  border: 1px solid #ccc; /* 美化边框 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* 添加阴影 */
  font-size: 14px;
  color: #333;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: 15px;
  overflow: hidden;

  &-title {
    position: relative;
    padding: 10px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    background-image: linear-gradient(137.48deg, #cef8ff 50%, #9affec 45%);

    i {
      position: absolute;
      font-size: 30px;
      top: 8px;
      right: 10px;
      cursor: pointer;
    }
  }
  &-chat {
    max-height: calc(100% - 150px); /* 调整聊天区域高度 */
    overflow-y: auto;
    flex: 1;
    padding: 5px 10px;
    margin-bottom: 40px;
    .chat-user {
      max-width: 80%;
      padding: 5px 10px;
      border-radius: 5px;
      display: flex;
      align-items: flex-start;
      flex-direction: row; // 修改为行方向

      .avatar-box-user {
        margin-left: 10px; // 头像在左侧
        .avatar {
          width: 30px;
          height: 30px;
          min-width: 30px;
          border-radius: 50%;
          border: 1px solid #ccc;
        }
      }
      .avatar-box-agent {
        margin-right: 10px; // 头像在左侧
        .avatar {
          width: 30px;
          height: 30px;
          min-width: 30px;
          border-radius: 50%;
          border: 1px solid #ccc;
        }
      }

      .message-content {
        background-color: #ffffff;
        border-radius: 5px;
        padding: 5px 10px;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
      }
    }
    .thinking {
      max-width: 90%;
      background-color: #c8ebff;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
      color: #333;
      padding: 5px 10px;
      border-radius: 5px;

      .avatar-box {
        margin-right: 10px; // 头像在左侧
        .avatar {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          border: 1px solid #ccc;
        }
      }

      .message-content {
        background-color: #f0f0f0;
        border-radius: 5px;
        padding: 5px 10px;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
      }
    }
  }
  &-foot {
    padding-top: 5px;
    display: flex;
    background-color: #ffffff;
    border-radius: 0 0 15px 15px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
    .btn-top {
      position: relative;
      width: 50px;
      height: 50px;
      margin: 12px 10px 0 0;
      border-radius: 25px;
      background-size: 300% 300%;
      backdrop-filter: blur(1rem);
      transition: 0.5s;
      animation: gradient_301 5s ease infinite;
      border: double 4px transparent;
      background-image: linear-gradient(#ffffff, #ffffff),
        linear-gradient(
          137.48deg,
          #a7f2ff 10%,
          #1d9b84 45%,
          #51e5ff 67%,
          #00b997 87%
        );
      background-origin: border-box;
      background-clip: content-box, border-box;
      i {
        font-size: 24px;
      }
    }
    .active {
      cursor: pointer;
      box-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
    }

    @keyframes gradient_301 {
      0% {
        background-position: 0% 50%;
      }

      50% {
        background-position: 100% 50%;
      }

      100% {
        background-position: 0% 50%;
      }
    }
  }
}

::v-deep a {
  word-wrap: break-word !important;
  display: flow !important;
}
:deep(.el-textarea__inner) {
  border: none;
  color: #333;
  background-color: #ffffff;
}
:deep(.el-textarea .el-input__count) {
  color: #333;
  background-color: #ffffff;
}
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

/* From Uiverse.io by terenceodonoghue */
.container {
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 50%;
  height: 96px;
  width: 96px;
  animation: rotate_3922 1.2s linear infinite;
  background-color: #9b59b6;
  background-image: linear-gradient(#9b59b6, #84cdfa, #5ad1cd);
}

.container span {
  position: absolute;
  border-radius: 50%;
  height: 100%;
  width: 100%;
  background-color: #9b59b6;
  background-image: linear-gradient(#9b59b6, #84cdfa, #5ad1cd);
}

.spinner {
  background-image: linear-gradient(rgb(186, 66, 255) 35%, rgb(0, 225, 255));
  width: 10px;
  height: 10px;
  animation: spinning82341 1.7s linear infinite;
  text-align: center;
  border-radius: 35px;
  filter: blur(1px);
  box-shadow: 0px -5px 20px 0px rgb(186, 66, 255),
    0px 5px 20px 0px rgb(0, 225, 255);
}

.spinner-box {
  background-color: rgb(36, 36, 36);
  width: 10px;
  height: 10px;
  color: #fff;
  border-radius: 35px;
  filter: blur(10px);
}
.spinner-text {
  padding-top: 5px;
  text-align: center;
  color: #333;
  font-size: 10px;
}

@keyframes spinning82341 {
  to {
    transform: rotate(360deg);
  }
}
.new-chat {
  position: absolute;
  bottom: 112px;
  left: 240px;
  padding: 5px 10px;
  border-radius: 100px;
  background: linear-gradient(45deg, #e0f9c9, #4afbd4);
  color: #4b4b4b;
}
</style>
